import React from 'react';
import PropTypes from 'prop-types';

export default class Tab extends React.Component {
    
    static get propTypes() {

        return {
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            id: PropTypes.string,
            children: PropTypes.any,
            isActive: PropTypes.bool,
        };
    }

    render() {
        
        return (
            <div { ...this.getUndeclaredProps() }>
                { this.props.children }
            </div>
        );
    }

    getUndeclaredProps() {

        const usedKeys = Object.keys(Tab.propTypes);
        return Object
            .fromEntries(Object.entries(this.props)
            .map(([key, value]) => {
                
                if (!usedKeys.includes(key))
                    return [key, value];

            })
            .filter((value) => value !== undefined));
    }
}